/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import location from '../../../public/assets/location-20.png';
import clock from '../../../public/assets/clock-batch.png';
import calender from '../../../public/assets/calendar-20.png';
import seatIcon from '../../../public/assets/Clip-path-group.png';
import HorizontalScroll from '../shared/HorizontalScroll';
import PageDataNotFound from '../shared/PageDataNotFound';
import CourseCTA from './course-cta-button';
import { ToastContext } from '../../contexts/toast-context-with-provider';

// const typeClasses = {
//   Online: 'bg-[#dff4cf] text-[#264909]',
//   Regular: 'bg-[#E3EAFF] text-[#002FFF]',
//   Weekend: 'bg-[#ffeecc] text-[#AA6311]',
// };
// time convert
function convertTime(timeStr) {
  const date = new Date(`1970-01-01T${timeStr}Z`);
  let hours = date.getUTCHours();
  let minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;
  hours = hours || 12;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${hours}:${minutes} ${ampm}`;
}

// change date format
function dateFormat(originalDate) {
  const adjustedDate = new Date(originalDate);
  // adjustedDate.setFullYear(2024, 10, 25);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  const formattedDate = adjustedDate.toLocaleDateString('en-US', options);
  return formattedDate;
}
function BatchlistDetails({
  // eslint-disable-next-line no-unused-vars
  hightlight, batchList, indexAmount, batchListedPrice, selectAmount, classHover, courseDetals, Amount, handleClick, handleRequestCall, batchName, productStatus, batchPrice, showBatchPopup, batchType, setHoverclass, coursBatchId, setBatchId, proceedBatchClick, setIndex,
}) {
  const { showToast } = useContext(ToastContext);
  // function for select batch from learn tab
  const selectLearnBatch = (index, id) => {
    if (index === indexAmount) {
      setHoverclass(true);
      setBatchId();
      setIndex();
    } else {
      setBatchId(id);
      setIndex(index);
      setHoverclass(false);
    }
  };
  const handleBatchClick = (res, index) => {
    const isEnrolmentAllowed = res?.enrolmentInfo?.isEnrolmentAllowed;

    if (res?.enrolmentInfo && isEnrolmentAllowed === false) {
      const message = res?.enrolmentInfo?.message || 'Enrolment is not allowed for this batch.';
      showToast(message);
      return;
    }

    if (batchType === 'learnBatch') {
      selectLearnBatch(index, res?.id, res?.name);
    } else if (typeof selectAmount === 'function') {
      selectAmount(batchListedPrice?.listedCost, index, res.id, res?.name);
    }
  };
  return (
    <div>
      <div className={`w-full ${!showBatchPopup ? 'lg:mb-[26px] mb-6' : ''} relative" id="my-section`}>
        {
          hightlight && (<div className="absolute w-[110%] -start-[35px] h-[110%] bg-[#DFF3FF] -z-10" />)
        }
        {
          batchType !== 'learnBatch' && (
            <div className={`${!showBatchPopup ? 'block' : 'hidden'} lg:mb-[18px] mb-4 font-semibold`}>
              <h2 className="lg:text-lg text-base text-black">Choose Your Batch</h2>
            </div>
          )
        }

        <HorizontalScroll className="gap-2 p-2">
          <div className={`${(batchList?.length < 2 && showBatchPopup) ? 'justify-center' : ''} !flex grid-cols-1  lg:grid-cols-4  gap-4`}>
            {batchList.length > 0 ? (batchList?.map((res, index) => {
              const infoList = [
                {
                  icon: calender,
                  label: 'Start Date:',
                  value: res?.commencementDate ? dateFormat(res?.commencementDate) : '-',
                },
                {
                  icon: clock,
                  label: 'Batch Time:',
                  value: res?.startTime && res?.endTime
                    ? `${convertTime(res?.startTime)} - ${convertTime(res?.endTime)}`
                    : '-',
                },
                // Only add Venue in offline case
                ...(res?.course?.type !== 'Online' && res?.venue?.name
                  ? [
                    {
                      icon: location,
                      label: 'Venue:',
                      value: res?.venue?.name,
                    },
                  ]
                  : []),
              ];
              return (
                <div key={res.id} className={`rounded-md cursor-pointer relative overflow-hidden bg-[linear-gradient(0.2deg,_#FFFFFF_-11.57%,_#F0F9FF_128.05%)] outline outline-[0.5px] outline-[#009FF9] after:absolute after:content-[''] after:left-0 after:right-0 after:w-full after:h-1  after:bottom-0  border border-b-0 border-transparent lg:p-5 ${res?.remainingSeats <= 20 ? 'lg:pb-0 pb-0' : 'lg:pb-5 pb-4'}  p-4 w-full lg:w-[378px] transition-all duration-[350ms] line-clamp-2 ${!classHover ? 'hover:outline-0  hover:bg-[linear-gradient(0.2deg,_#FFFFFF_-11.57%,_#C9E8FD_128.05%)] hover:after:bg-[#009FF9] hover:border-b-0  hover:border hover:border-[#009FF9]  ease-out hover:scale-[1.02] hover:shadow-[0px_0px_7px_0px_#b8e5ff]' : ''} outline-offset-[-2px] flex-flexAuto ${index === indexAmount && (Amount || batchType === 'learnBatch') ? '!bg-[linear-gradient(0.2deg,_#FFFFFF_-11.57%,_#C9E8FD_128.05%)] after:bg-[#009FF9] !border-b-0 !border !border-[#009FF9] !outline-none' : ''}`} onClick={() => handleBatchClick(res, index)}>
                  <div className={`${res?.remainingSeats <= 20 ? 'lg:mb-4 mb-[44px]' : ''}`}>
                    <div className="flex items-center lg:mb-4 mb-4">
                      {
                      indexAmount === index ? (
                        <svg width="24" height="24" className="lg:w-6 lg:h-6 w-[18px] h-[18px]" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M8.93544 2.21965C10.4374 0.116886 13.5626 0.116886 15.0646 2.21965L15.3037 2.55442C15.568 2.9245 16.0119 3.12265 16.4638 3.07244L17.5296 2.95401C19.9283 2.6875 21.9551 4.71428 21.6886 7.11293L21.5702 8.17875C21.52 8.63074 21.7181 9.07456 22.0882 9.3389L22.423 9.57802C24.5257 11.0799 24.5257 14.2051 22.423 15.7072L22.0882 15.9463C21.7181 16.2106 21.52 16.6545 21.5702 17.1064L21.6886 18.1722C21.9551 20.5709 19.9283 22.5977 17.5296 22.3312L16.4638 22.2128C16.0119 22.1626 15.568 22.3607 15.3037 22.7307L15.0646 23.0655C13.5626 25.1683 10.4375 25.1683 8.93544 23.0655L8.69632 22.7307C8.43198 22.3607 7.98816 22.1626 7.53616 22.2128L6.47035 22.3312C4.0717 22.5977 2.04492 20.5709 2.31143 18.1722L2.42986 17.1064C2.48008 16.6545 2.28192 16.2106 1.91184 15.9463L1.57707 15.7072C-0.525692 14.2051 -0.525692 11.0801 1.57707 9.57802L1.91184 9.3389C2.28192 9.07456 2.48008 8.63074 2.42986 8.17874L2.31143 7.11293C2.04492 4.71428 4.0717 2.6875 6.47035 2.95401L7.53617 3.07244C7.98816 3.12265 8.43198 2.9245 8.69632 2.55442L8.93544 2.21965ZM16.6537 9.24422C17.144 9.73447 17.144 10.5293 16.6537 11.0196L11.8597 15.8136C11.2439 16.4295 10.2454 16.4295 9.62966 15.8136L7.34629 13.5303C6.85605 13.04 6.85605 12.2452 7.34629 11.7549C7.83654 11.2647 8.63138 11.2647 9.12163 11.7549L10.7447 13.378L14.8784 9.24422C15.3686 8.75398 16.1635 8.75398 16.6537 9.24422Z" fill="#0093FF" />
                        </svg>
                      ) : (<input className="lg:w-6 lg:h-6 w-[18px] h-[18px] border-2" value={indexAmount} type="radio" />)
                    }

                      <h4 className="lg:text-lg text-base font-semibold capitalize  ps-2 line-clamp-1 text-black">{res?.name}</h4>
                    </div>
                    <div className="flex justify-between overflow-hidden">
                      <ul className="w-full flex-wrap">
                        {infoList.map((item, inDx) => (
                          <li
                            // eslint-disable-next-line react/no-array-index-key
                            key={inDx}
                            className="lg:whitespace-nowrap whitespace-normal lg:mb-4 mb-3.5 flex items-center lg:text-base text-sm text-black last:mb-0"
                          >
                            <span className="block pe-2">
                              <Image
                                width={20}
                                height={20}
                                className="w-[18px] h-[18px] lg:w-5 lg:h-5"
                                src={item.icon}
                                alt={item.label}
                              />
                            </span>
                            <div className="flex">
                              <p className="font-medium">{item.label}</p>
                              <p className="font-light pl-2">{item.value}</p>
                            </div>
                          </li>
                        ))}
                      </ul>

                    </div>
                  </div>
                  {
                  res?.remainingSeats <= 20 && (
                  <div className={`${res?.course?.type === 'Online' ? '' : ''} flex`}>
                    <ul className="flex flex-wrap justify-center w-full items-center lg:relative absolute bottom-[2px] left-0 right-0">
                      {res?.course?.type !== 'Online'
                      && (
                        <li className="flex items-center bg-[#FFD9D7] rounded-tl-lg rounded-tr-lg px-[15px]">
                          {res?.remainingSeats
                            && (
                              <>
                                <Image width={19} height={19} className="lg:w-9 lg:h-9 w-7 h-7" src={seatIcon} alt="seatIcon" />
                                <span className="ps-2 lg:text-sm text-xs font-medium text-[#FE4135]">
                                  {`Hurry, only ${res?.remainingSeats} seats left!`}
                                </span>
                              </>
                            )}
                        </li>
                      )}
                      {/* {
                              batchListedPrice?.listedCost
                              && (
                                <li className={`${res?.course?.type === 'Online' ? 'lg:bottom-4' : ''} absolute right-0 bg-center text-white flex items-center justify-center py-[7px] lg:px-4 px-[10px] tagSkew bg-customBlue`}>
                                  <span className="lg:text-sm text-xs">{batchListedPrice?.listedCost}</span>
                                </li>
                              )
                            } */}

                    </ul>
                  </div>
                  )
}
                </div>
              );
            })) : (
              <PageDataNotFound noMsg="There are currently no active batches" />
            )}
          </div>
        </HorizontalScroll>
      </div>
      {/* {showBatchPopup && batchList?.length > 1 && (
        <div className="flex justify-center my-4 ">
          <div className="flex gap-2">
            {batchList.map((_, i) => (
              <span
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                className={`h-2 rounded-full transition-all duration-300 ${i === indexAmount
                  ? 'bg-[#FE4135] w-4'
                  : 'bg-gray-300 w-2'
                }`}
              />
            ))}
          </div>
        </div>
      )} */}
      <div className={`${batchType === 'learnBatch' ? 'block' : 'hidden'} pt-[26px] flex justify-center`}>
        <button type="button" onClick={() => proceedBatchClick(coursBatchId)} className={`${coursBatchId ? 'bg-[#045692]' : 'bg-[#9D9D9D]'} text-white text-base rounded-lg lg:py-[18px] py-4 lg:w-3/5 w-full font-semibold`}>Proceed</button>
      </div>
      {
        showBatchPopup && (
          <div className="shadow-[0px_-1px_0px_#5B95F733] mt-6">
            <CourseCTA handleClick={handleClick} handleRequestCall={handleRequestCall} showBatchPopup={showBatchPopup} cusPadding="pb-0 pt-3" Amount={Amount} batchName={batchName} productStatus={productStatus} batchPrice={batchPrice} />
          </div>
        )
      }

      {/* <hr className="border-2 my-[22px] border-[#E2E8F0] block lg:hidden  relative right-0 left-0" /> */}
    </div>
  );
}
BatchlistDetails.propTypes = {
  hightlight: PropTypes.bool,
  batchList: PropTypes.arrayOf(PropTypes.object),
  indexAmount: PropTypes.number,
  batchListedPrice: PropTypes.objectOf(PropTypes.any),
  selectAmount: PropTypes.func,
  classHover: PropTypes.any,
  courseDetals: PropTypes.any,
  Amount: PropTypes.any,
};

export default BatchlistDetails;
